import React from 'react'
import './aboutMe.css'
import ofek from '../../images/ofekpro.png'

function AboutMe() {
  return (
    <div className="about__container" id="about-me">
     <div>
      <img style={{width: '300px', height: '400px'}} src={ofek} alt="ofek icon"/>
     </div>
     <div className="about__text">
       <h1>ABOUT ME</h1>
       <p>My name is Ofek,i'm 23 years old.I'm Junior Full Stack Developer.
Web developer(full stack) student at HackerU colleage.
I'm a kind, sociable person that looking for my next challange
 in web development(full stack),
 with a willingness to work in teams.
Knoledge of JavaScript,Css,Html,Sql,
MongoDB,jquery,
bootstrap,nodeJs,react.js,next.js,Angular,vue.js,nuxt.js.
In addition, have 10 computer study units from Kugel
 High School in Holon, Israel. 
 5 units of computer science study in c# and 5 units
  of study in android (application development).
also, i am a freelancer in web development.
 So let me build your next website! You will not regret it!
</p>
     </div>
    </div>
  )
}

export default AboutMe
